exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image-in {\r\n  width: 100%;\r\n}\r\n\r\n.image-out {\r\n  width: 35px;\r\n  height: 45px;\r\n  overflow: hidden;\r\n  float: left;\r\n  margin-right: 10px;\r\n}\r\n\r\n.opt-text {\r\n  line-height: 45px\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Home/OneDrive/Documents/hotellife_web/src/app/confirm-order/confirm-order.component.css
// module id = ../../../../../src/app/confirm-order/confirm-order.component.css
// module chunks = main